import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DataManager, Query, ODataV4Adaptor, Predicate } from '@syncfusion/ej2-data';
import { SaveEventArgs, EditSettingsModel, SortSettingsModel, PageSettingsModel, setChecked } from '@syncfusion/ej2-angular-grids';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { environment } from 'src/environments/environment';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Browser } from '@syncfusion/ej2-base';
import { Dialog } from '@syncfusion/ej2-angular-popups';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { __values } from 'tslib';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})
export class ActivityComponent implements OnInit, OnChanges {
  // @Input() relatedTypeId: number;
  // @Input() recordId: number;
  @Input() relatedConditions: { relatedTypeId: number; recordId: number }[] = [];
  @Output() closeScopeInfo = new EventEmitter<void>();
  
  @ViewChild('callTypeTemplate', { static: true }) callTypeTemplate: any;
  title = "Activity";
  data!: DataManager;
  query!: Query;
  oldActivityData!: DataManager;
  oldActivityquery!: Query;
  baseUrl: string = environment.baseUrl.replace('/api/', '/odata/');
  editSettings!: EditSettingsModel;
  sortSettings!: SortSettingsModel;
  toolbar!: string[];
  columns!: object[];
  oldActivityColumns!: object[];
  public pageOptions: PageSettingsModel =  { pageSize: 25, pageSizes: [25, 50, 100], pageCount: 5 };
  public submitClicked: boolean = false;
  public formData!: UntypedFormGroup;
  currentUser: any
  filterSettings!: Object;
  oldActivityFilterSettings!: Object;

  activityTypeData: Object[] = [
    { Id: 1, Name: 'Call' },
    { Id: 2, Name: 'Task' },
    { Id: 3, Name: 'Event' },
    { Id: 4, Name: 'Email' }
  ];
  currentActivityType: number = 1;
  activityTypeQuery = new Query();
  activityStatusData: Object[] = [
    { Id: 1, Name: 'Pending' },
    { Id: 2, Name: 'Completed' },
    { Id: 3, Name: 'Cancelled' }
  ];
  activityStatusQuery = new Query();

  callTypeData: Object[] = [
    { Id: 'In Bound', Name: 'In Bound' },
    { Id: 'Out Bound', Name: 'Out Bound' },
  ];
  callTypeQuery = new Query();

  eventTypeData: Object[] = [
    { Id: 'Demo', Name: 'Demo' },
    { Id: 'Visit', Name: 'Visit' },
    { Id: 'Training', Name: 'Training' },
    { Id: 'Meeting', Name: 'Meeting' },
    { Id: 'Other', Name: 'Other' },
  ];
  eventTypeQuery = new Query();
  currentyEventType:string = "Other";

  constructor(private authenticationService: AuthenticationService, private formBuilder: UntypedFormBuilder, private route: ActivatedRoute) { }

  ngOnInit(): void {

    const storedActivityType = +(localStorage.getItem('lastActivityType'));
    this.currentActivityType = storedActivityType ? storedActivityType : 1;

    this.sortSettings = { columns: [{ field: 'DateTime', direction: 'Descending' }] };
    this.filterSettings = { type: "Menu" };
    this.oldActivityFilterSettings = { type: "Menu" };
    this.editSettings = { allowAdding: true, allowEditing: true, mode: 'Dialog' };
    this.toolbar = ['Add']

    this.currentUser = this.authenticationService.currentUserValue;
    this.columns = [
      { field: 'Id', headerText: 'Id', isPrimaryKey: true, visible: false },
      { field: 'Name', headerText: 'Name', template:this.callTypeTemplate },
      { field: 'DateTime', headerText: '',visible: false}
    ]

    this.oldActivityColumns = [
      { field: 'Id', headerText: 'Id', isPrimaryKey: true, visible: false },
      { field: 'Name', headerText: 'Name', template : this.callTypeTemplate},
      { field: 'DateTime', headerText: '',visible: false}
    ]

    this.data = new DataManager({
      url: this.baseUrl + "Activity",
      adaptor: new ODataV4Adaptor(),
      headers: [{ 'Authorization': 'Bearer ' + this.currentUser.token }]
    });

    this.oldActivityData = new DataManager({
      url: this.baseUrl + 'Activity',
      adaptor: new ODataV4Adaptor(),
      headers: [{ 'Authorization': 'Bearer ' + this.currentUser.token }]
    });
    this.refreshQueries();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['relatedConditions'] && !changes['relatedConditions'].firstChange) {
      this.refreshQueries();
    }
  }

  private refreshQueries(): void {
    const predicate = this.buildRelatedPredicate();
    if (!predicate) {
      this.query = new Query().where('Id', 'equal', -1);
      this.oldActivityquery = new Query().where('Id', 'equal', -1);
      return;
    }

    this.query = new Query()
      .expand('ActivityType, ActivityCall, ActivityTask, ActivityEmail, ActivityEvents, ActivityStatus, CreatedBy')
      .where(predicate.and('ActivityStatusId', 'equal', 1));

    this.oldActivityquery = new Query()
      .expand('ActivityType, ActivityCall, ActivityTask, ActivityEvents, ActivityEmail, ActivityStatus, CreatedBy')
      .where(predicate.and('ActivityStatusId', 'notEqual', 1));
  }

  private buildRelatedPredicate(): Predicate | null {
    let finalPredicate: Predicate | null = null;
    for (const condition of this.relatedConditions) {
      const predicate = new Predicate('RelatedTypeId', 'equal', condition.relatedTypeId)
        .and('RelatedId', 'equal', condition.recordId);
      finalPredicate = finalPredicate ? finalPredicate.or(predicate) : predicate;
    }
    return finalPredicate;
  }

  actionBegin(args: SaveEventArgs): void {
    
    let objData: any = args.rowData;
    if (args.requestType === 'beginEdit' || args.requestType === 'add') {
      this.submitClicked = false;

      if (args.requestType === 'add') {
        const relatedCondition = this.relatedConditions?.[0];
        this.formData = this.formBuilder.group({
          Id: [0],
          Name: ['', [Validators.required]],
          RelatedTypeId: [relatedCondition?.relatedTypeId ?? 0],
          RelatedId: [relatedCondition?.recordId ?? 0],
          ActivityTypeId: [this.currentActivityType, [Validators.required]],
          DateTime: [new Date(), [Validators.required]],
          ActivityStatusId: [1, [Validators.required]],
          ActivityCall: this.getActivityCallFormGroup(null),
          ActivityTask: this.getActivityTaskFormGroup(null),
          ActivityEvents: this.getActivityEventsFormGroup(null),
          ActivityEmail: this.getActivityEmailFormGroup(null),
        });
      }
      else {
        this.formData = this.formBuilder.group({
          Id: [objData.Id ? objData.Id : 0],
          Name: [objData.Name, [Validators.required]],
          ActivityTypeId: [objData.ActivityTypeId, [Validators.required]],
          DateTime: [objData.DateTime, [Validators.required]],
          ActivityStatusId: [objData.ActivityStatusId, [Validators.required]],
          ActivityCall: this.getActivityCallFormGroup(objData.ActivityCall),
          ActivityEvents: this.getActivityEventsFormGroup(objData.ActivityEvents),
          ActivityTask: this.getActivityTaskFormGroup(objData.ActivityTask),
          ActivityEmail: this.getActivityEmailFormGroup(objData.ActivityEmail),
        });
      }
    }
    if (args.requestType === 'save') {
      this.submitClicked = true;
      this.clearAllErrors(this.formData.value.ActivityTypeId);
      if (this.formData.valid) {
        var data = this.formData.value;
        data.ActivityCall = data.ActivityTypeId == 1 ? data.ActivityCall : null;
        data.ActivityTask = data.ActivityTypeId == 2 ? data.ActivityTask : null;
        data.ActivityEvents = data.ActivityTypeId == 3 ? data.ActivityEvents : null;
        data.ActivityEmail = data.ActivityTypeId == 4 ? data.ActivityEmail : null;
        args.data = data;
      } else {
        args.cancel = true;
      }
    }
  }

  clearAllErrors(activityTypeId: number) {
    switch (activityTypeId) {
      case 1:
        this.formData.get('ActivityCall').markAsTouched();
        this.clearErrors(this.formData.get('ActivityTask') as FormGroup);
        this.clearErrors(this.formData.get('ActivityEvents') as FormGroup);
        this.clearErrors(this.formData.get('ActivityEmail') as FormGroup);
        break;
      case 2:
        this.formData.get('ActivityTask').markAsTouched();
        this.clearErrors(this.formData.get('ActivityCall') as FormGroup);
        this.clearErrors(this.formData.get('ActivityEvents') as FormGroup);
        this.clearErrors(this.formData.get('ActivityEmail') as FormGroup);
        break;
      case 3:
        this.formData.get('ActivityEvents').markAsTouched();
        this.clearErrors(this.formData.get('ActivityCall') as FormGroup);
        this.clearErrors(this.formData.get('ActivityTask') as FormGroup);
        this.clearErrors(this.formData.get('ActivityEmail') as FormGroup);
        break;
      case 4:
        this.formData.get('ActivityEmail').markAsTouched();
        this.clearErrors(this.formData.get('ActivityCall') as FormGroup);
        this.clearErrors(this.formData.get('ActivityTask') as FormGroup);
        this.clearErrors(this.formData.get('ActivityEvents') as FormGroup);
        break;
    }
  }

  clearErrors(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(controlName => {
      const control = formGroup.get(controlName);
      control.setErrors(null);
    });
  }

  private getActivityCallFormGroup(activityCall: any): FormGroup {
    if (activityCall) {
      return this.formBuilder.group({
        Comments: [activityCall.Comments, [Validators.required]],
        Type: [activityCall.Type, [Validators.required]]
      });
    } else {
      return this.formBuilder.group({
        Comments: ['', [Validators.required]],
        Type: ['', [Validators.required]]
      });
    }
  }

  private getActivityEventsFormGroup(activityEvents: any): FormGroup {
    const currentyEventType = localStorage.getItem('lastEventType');
    this.currentyEventType = currentyEventType ? currentyEventType : "Other";
    if (activityEvents) {
      return this.formBuilder.group({
        Description: [activityEvents.Description, [Validators.required]],
        Type: [activityEvents.Type, [Validators.required]],
        Start: [activityEvents.Start],
        End: [activityEvents.End],
        Location: [activityEvents.Location, [Validators.required]],
        Latitude: [activityEvents.Latitude],
        Longitude: [activityEvents.Longitude]
      });
    } else {
      return this.formBuilder.group({
        Description: ['', [Validators.required]],
        Type: [this.currentyEventType, [Validators.required]],
        Start: [new Date()],
        End: [],
        Location: ['', [Validators.required]],
        Latitude: [0],
        Longitude: [0]
      });
    }
  }

  private getActivityTaskFormGroup(activityTask: any): FormGroup {
    if (activityTask) {
      return this.formBuilder.group({
        Status: [activityTask.Status, [Validators.required]],
        DueDate: [activityTask.DueDate],
        Description: [activityTask.Description, [Validators.required]],
        CompletedDate: [activityTask.CompletedDate],
        AssignToId: [this.authenticationService.currentUserValue.id]
      });
    } else {
      return this.formBuilder.group({
        Status: ['', [Validators.required]],
        DueDate: [],
        Description: ['', [Validators.required]],
        CompletedDate: [],
        AssignToId: [2]
      });
    }
  }

  private getActivityEmailFormGroup(activityEmail: any): FormGroup {
    if (activityEmail) {
      return this.formBuilder.group({
        From: [activityEmail.From, [Validators.required]],
        To: [activityEmail.To, [Validators.required]],
        CC: [activityEmail.CC],
        BCC: [activityEmail.BCC],
        Subject: [activityEmail.Subject, [Validators.required]],
        Body: [activityEmail.Body, [Validators.required]]
      });
    } else {
      return this.formBuilder.group({
        From: ['', [Validators.required]],
        To: ['', [Validators.required]],
        CC: [''],
        BCC: [''],
        Subject: ['', [Validators.required]],
        Body: ['', [Validators.required]]
      });
    }
  }

  changeEventType(args){
    if(args.itemData)
    {
      this.currentyEventType = args.itemData.Name;
      localStorage.setItem('lastEventType', this.currentyEventType);
    }
  }
  
  actionComplete(args): void {
    if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
      const dialog = args.dialog;
      dialog.showCloseIcon = false;
      dialog.element.style.maxHeight = '';
      dialog.height = '60vh';
      dialog.width = '50%';

      if (args.requestType === 'add') {
        (args.form.elements.namedItem('Name') as HTMLInputElement).focus();
        args.dialog.header = 'Enter your activity here';
      }
    }
    if (args.requestType === 'save') {
      this.submitClicked = true;
      if (this.formData.valid) {
        args.data = this.formData.value;
      } else {
        args.cancel = true;
      }
    }
  }

  get f() {
    return this.formData.controls;
  }

  get ac() {
    return this.formData.controls.ActivityCall['controls'];
  }

  get ae() {
    return this.formData.controls.ActivityEvents['controls'];
  }

  get at() {
    return this.formData.controls.ActivityTask['controls'];
  }

  get am() {
    return this.formData.controls.ActivityEmail['controls'];
  }

  public onFiltering(e, obj: string) {
    e.preventDefaultAction = true;
    var predicate = new Predicate('Name', 'contains', e.text);
    var query = new Query();
    //frame the query based on search string with filter type.
    query = (e.text != "") ? query.where(predicate) : query;

    //pass the filter data source, filter query to updateData method.
    switch (obj) {
      // case 'at':
      //   e.updateData(this.activityTypeData, this.activityTypeQuery);
      //   break;
      case 'as':
        e.updateData(this.activityStatusData, this.activityStatusQuery);
        break;
      case 'ct':
        e.updateData(this.callTypeData, this.callTypeQuery);
        break;
      case 'et':
        e.updateData(this.eventTypeData, this.eventTypeQuery);
        break;
    }
  }

  close() {
    this.closeScopeInfo.emit();
  }

  formatDateTime(date: Date): string {
    const today = new Date();
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
    const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);
    const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
  
    if (date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()) {
      return new DatePipe('en-US').transform(date, 'h:mm a');
    } else if (date.getDate() === yesterday.getDate() &&
               date.getMonth() === yesterday.getMonth() &&
               date.getFullYear() === yesterday.getFullYear()) {
      return `Yesterday, ${new DatePipe('en-US').transform(date, 'h:mm a')}`;
    } else if (sevenDaysAgo <= date && date < today) {
      return new DatePipe('en-US').transform(date, 'EEE, h:mm a');
    } else if (date.getDate() === tomorrow.getDate() &&
          date.getMonth() === tomorrow.getMonth() &&
          date.getFullYear() === tomorrow.getFullYear()) {
      return `Tomorrow, ${new DatePipe('en-US').transform(date, 'h:mm a')}`;
    } else {
      return new DatePipe('en-US').transform(date, 'd-MMM h:mm a');
    }
  }

  setType(activityType:string){
    switch (activityType){
      case "Call" : this.f.ActivityTypeId.setValue(1);
      break;
      case  "Task" : this.f.ActivityTypeId.setValue(2);
      break;
      case  "Event" : this.f.ActivityTypeId.setValue(3);
      break;
      case  "Email" : this.f.ActivityTypeId.setValue(4);
      break;
    }
    this.currentActivityType = this.f.ActivityTypeId.value;
    localStorage.setItem('lastActivityType', this.f.ActivityTypeId.value);    
  }

  setCompleteDateTime() {
    if (this.ae) {
      this.ae.End.setValue(new Date());
      this.f.ActivityStatusId.setValue(2);
    }
  }

  setCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;

          this.ae.Latitude.setValue(latitude);
          this.ae.Longitude.setValue(longitude);
          
        },
        (error) => {
          console.error('Geolocation error:', error);
          alert('Unable to retrieve your location. Please check permissions or try again.');
        }
      );
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  }
}
